import React, {useState} from 'react';
import {Col, Collapse, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import {
  AdministrativeUnitOverviewFilterDto, initialAdministrativeUnitOverviewFilterDtoValues
} from "app/edozvola/administrative-unit-overview/model/administrative-unit-overview.model";
import {useFormik} from "formik";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import {Button, Label } from 'edozvola-frontend-lib/dist/ui';
import {PaginatedDropdown} from "edozvola-frontend-lib/dist/ui/components/paginated-dropdown";
import { isEqual } from 'lodash';
import {
  fetchAuthorityCodebookQuery,
  fetchCityMunicipalitiesWithCountyQuery,
  fetchCountiesQuery
} from "app/edozvola/codebooks/codebooks.queries";
import {paginationKeys} from "app/shared/util/pagination.constants";

export interface AdministrativeUnitFilterProps {
  filterForm: AdministrativeUnitOverviewFilterDto;
  setFilterForm: any;
  modal: any;
  closeModal: any;
}

const AdministrativeUnitFilterModal = (props: AdministrativeUnitFilterProps) => {
  const [affiliationAreaSectionShown, setAffiliationAreaSectionShown] = useState<boolean>(true);
  const [authoritySectionShown, setAuthoritySectionShown] = useState<boolean>(true);

  const formik = useFormik({
    initialValues: props.filterForm,
    onSubmit: values => {
      props.setFilterForm(values);
      localStorage.setItem(`${paginationKeys.ADMINISTRATIVE_UNIT_OVERVIEW}-filter-form`, JSON.stringify(values));
      props.closeModal();
    },
    enableReinitialize: true
  });

  const closeModal = () => {
    formik.setValues(props.filterForm);
    props.closeModal();
  }

  const clearFilter = () => {
    formik.resetForm({ values: initialAdministrativeUnitOverviewFilterDtoValues });
  };

  const {data: countiesOptions} = fetchCountiesQuery();
  const {data: cityMunicipalityOptions} = fetchCityMunicipalitiesWithCountyQuery();
  const {data: authorityOptions} = fetchAuthorityCodebookQuery();

  return (
    <Modal scrollable size={'xl'} backdrop="static" isOpen={!!props.modal} toggle={() => closeModal()} centered={true}>
      <ModalHeader close={<FontAwesomeIcon className={'hand'} icon={faXmark} />} onClick={e => closeModal()} className={'d-flex'}>
        Pretraga nadležnih ureda
      </ModalHeader>
      <ModalBody className={'modal-body-dropdown-on-top'}>
        <Row className={'hand'} onClick={() => setAffiliationAreaSectionShown(prevState => !prevState)}>
          <Col xs={6}>
            <div className={'form-header'}>Područje nadležnosti</div>
          </Col>
          <Col xs={6} className={'d-flex justify-content-end'}>
            <FontAwesomeIcon size="lg" color="outline" icon={affiliationAreaSectionShown ? 'chevron-circle-up' : 'chevron-circle-down'} />
          </Col>
        </Row>
          <Collapse isOpen={affiliationAreaSectionShown}>
            <Row>
              <Col xs={6}>
                <FormGroup>
                <Label labelText={'Županija'} />
                <PaginatedDropdown
                  onItemSelect={option => {
                    formik.setFieldValue('cityMunicipality', []);
                    formik.setFieldValue('authority', []);
                    formik.setFieldValue('county', option)
                  }}
                  selected={formik.values.county}
                  labelKey={'value'}
                  options={countiesOptions ?? []}
                  disabled={formik.values?.cityMunicipality.length > 0 || formik.values?.authority.length > 0}
                  positionFixed
                  clearButton
                  />
                </FormGroup>
              </Col>
              <Col xs={6}>
                <FormGroup>
                <Label labelText={'Grad/općina'} />
                <PaginatedDropdown
                  onItemSelect={option => {
                    formik.setFieldValue('county', []);
                    formik.setFieldValue('authority', []);
                    formik.setFieldValue('cityMunicipality', option);
                  }}
                  selected={formik.values.cityMunicipality}
                  labelKey={'value'}
                  options={cityMunicipalityOptions ?? []}
                  disabled={formik.values?.county.length > 0 || formik.values?.authority.length > 0}
                  positionFixed
                  clearButton
                />
                </FormGroup>
              </Col>
            </Row>
          </Collapse>
        <Row className={'hand'} onClick={() => setAuthoritySectionShown(prevState => !prevState)}>
          <Col xs={6}>
            <div className={'form-header'}>Nadležno tijelo</div>
          </Col>
          <Col xs={6} className={'d-flex justify-content-end'}>
            <FontAwesomeIcon size="lg" color="outline" icon={authoritySectionShown ? 'chevron-circle-up' : 'chevron-circle-down'} />
          </Col>
        </Row>
        <Collapse isOpen={authoritySectionShown}>
          <Row>
            <Col xs={6}>
              <FormGroup>
              <Label labelText={'Nadležno tijelo'} />
              <PaginatedDropdown
                onItemSelect={option => {
                  formik.setFieldValue('cityMunicipality', []);
                  formik.setFieldValue('county', []);
                  formik.setFieldValue('authority', option);
                }}
                selected={formik.values.authority}
                labelKey={'value'}
                options={authorityOptions ?? []}
                disabled={formik.values?.county.length > 0 || formik.values?.cityMunicipality.length > 0}
                positionFixed
                clearButton
              />
              </FormGroup>
            </Col>
          </Row>
        </Collapse>
        <ModalFooter>
          <div>
            <Button
              color={'secondary'}
              size={'lg'}
              label={'Poništi'}
              prependIcon={'repeat'}
              onClick={clearFilter}
              disabled={isEqual(formik.values, initialAdministrativeUnitOverviewFilterDtoValues)}
            />
          </div>
          <div className={'float-end'}>
            <Button
              color={'info'}
              size={'lg'}
              label={'Pretraži'}
              prependIcon={'search'}
              onClick={formik.submitForm}
              disabled={!formik.isValid || isEqual(formik.values, props.filterForm)}
            />
          </div>
        </ModalFooter>
      </ModalBody>
    </Modal>
  );
}

export default AdministrativeUnitFilterModal;
